import createIcon from '../../createIcon';

/**
 * @component @name NetworkWifi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQgOC40OEMyMC45MyA1LjQgMTYuNjkgMy41IDEyIDMuNUM3LjMxIDMuNSAzLjA3IDUuNCAwIDguNDhMMTIgMjAuNUwyNCA4LjQ4Wk0yLjkyIDguNTdDNS41MSA2LjU4IDguNjcgNS41IDEyIDUuNUMxNS4zMyA1LjUgMTguNDkgNi41OCAyMS4wOCA4LjU3TDE5LjY1IDEwQzE3LjUgOC40NCAxNC44NiA3LjUgMTIgNy41QzkuMTQgNy41IDYuNSA4LjQ0IDQuMzUgMTAuMDFMMi45MiA4LjU3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NetworkWifi = createIcon('NetworkWifi', [
  [
    'path',
    {
      d: 'M24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48ZM2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L19.65 10C17.5 8.44 14.86 7.5 12 7.5C9.14 7.5 6.5 8.44 4.35 10.01L2.92 8.57Z',
      key: '1rve2w',
    },
  ],
]);

export default NetworkWifi;
